import { createFileRoute } from "@tanstack/react-router";
import { ConsentSignPage } from "@/features/consents";
import { patientDomainIdFromProfile } from "@/shared/lib/patient-profile";

export const Route = createFileRoute("/consent/sign")({
  staticData: { fullBleed: true },
  component: Page,
});

function Page() {
  const { profile } = Route.useRouteContext();
  const { redirect } = Route.useSearch();
  return <ConsentSignPage patientId={patientDomainIdFromProfile(profile)} redirect={redirect} />;
}
